import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { externalReferenceBackend } from './external-reference.backend';
import { externalReferenceReducer } from './external-reference.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('externalReference', externalReferenceReducer),
    BackendModule.forFeature('externalReference', externalReferenceBackend),
  ],
})
export class DatastoreExternalReferenceModule {}
